import {Controller} from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default abstract class SelectTagsController extends Controller<HTMLSelectElement> {
  protected select: TomSelect | null = null;

  /**
   * Optionally override this method to provide a custom template
   * for formatting Tom Select results.
   */
  renderOption?(item: any, escape: (str: string) => string): string;

  /**
   * Determines if the select should allow multiple selections.
   * Override in the derived controller to enable multiselect.
   */
  get multiple(): boolean {
    return true;
  }

  connect(): void {
    const config: any = {
      plugins: ['remove_button'],
      placeholder: "Введите станции метро",
      create: true, // Enable tags
      createOnBlur: true,
      delimiter: ',', // Equivalent to tokenSeparators
      persist: false,
      maxItems: 3,
      hideSelected: true,
      closeAfterSelect: true,
      render: {
        option: this.renderOption ?
          (item: any, escape: any) => this.renderOption!(item, escape) :
          undefined,
        // no_results: () => '<div class="no-results">Ничего не найдено</div>'
      },
      onFocus: () => {
        this.element.classList.remove("is-invalid");
      },
      onChange: () => {
        this.element.classList.remove("is-invalid");
      }
    };

    // Add Bootstrap 5 theme classes
    config.dropdownClass = 'dropdown-menu';
    config.dropdownContentClass = 'dropdown-content';

    this.select = new TomSelect(this.element, config);
  }

  disconnect(): void {
    if (this.select) {
      this.select.destroy();
      this.select = null;
    }
  }
}